import(/* webpackMode: "eager" */ "/vercel/path0/src/components/gym-and-wellness/GymAndWellnessComponent.tsx")